module.exports = __webpack_public_path__ + "static/Verne1-fb7c68ac77b29b055e4c2fee34ddee77.png";